import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'dark' | 'light';

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'dark',
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
      toggle: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark';
        set({ theme: next });
        applyTheme(next);
      },
    }),
    { name: 'spreadbot-theme' }
  )
);

export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.remove('theme-dark', 'theme-light', 'dark');
  root.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light');
  if (theme === 'dark') root.classList.add('dark');
  root.style.colorScheme = theme;
}

// init on first load
if (typeof window !== 'undefined') {
  const stored = localStorage.getItem('spreadbot-theme');
  let initial: Theme = 'dark';
  try {
    if (stored) initial = (JSON.parse(stored).state?.theme ?? 'dark') as Theme;
  } catch {}
  applyTheme(initial);
}
